import { Link, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { CartFragment } from '../../../graphql/magento'
import { shouldShowCaliforniaProp65Warning } from '../../../lib/cart/item'

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.component.link};
`

export interface CaliforniaProp65WarningProps {
  className?: string
  items: CartFragment['items']
  shippingAddress: CartFragment['shipping_addresses'][0]
}

const CaliforniaProp65Warning: React.FC<CaliforniaProp65WarningProps> = ({
  className,
  items,
  shippingAddress,
}) => {
  if (!items || !shouldShowCaliforniaProp65Warning({ items, shippingAddress })) {
    return null
  }

  return (
    <div className={className}>
      <Typography display="block" variant="caption">
        Any product with an ** is subject to <strong>WARNING</strong> Reproductive Harm
      </Typography>
      <StyledLink
        href="https://www.p65warnings.ca.gov/food"
        rel="noopener"
        target="_blank"
        variant="caption"
      >
        www.P65Warnings.ca.gov/food
      </StyledLink>
    </div>
  )
}

const StyledCaliforniaProp65Warning = styled(CaliforniaProp65Warning)({
  flexBasis: '100%',
  lineHeight: '14px',
  marginBottom: '8px',
  marginTop: '8px',
  textAlign: 'center',
  '.MuiTypography-caption': {
    '&, strong': {
      fontSize: '12px',
    },
  },
})

export default StyledCaliforniaProp65Warning
